// Campus photo for /colleges/washington-university-in-st-louis: CC BY-SA 4.0, by Doc2129, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ABrookings_Hall.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/washington-university-in-st-louis/; credited under the photo.
const photo = {
    "slug": "washington-university-in-st-louis",
    "alt": "Brookings Hall at the end of brick walks across the lawn at Washington University in St. Louis, Missouri",
    "src": "/colleges/washington-university-in-st-louis/campus-1600.webp",
    "srcSmall": "/colleges/washington-university-in-st-louis/campus-800.webp",
    "srcMid": "/colleges/washington-university-in-st-louis/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/washington-university-in-st-louis/og.jpg",
    "title": "Brookings Hall",
    "author": "Doc2129",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ABrookings_Hall.jpg",
    "read": "2026-10-01"
};

export default photo;
